export default __webpack_public_path__ + "static/media/blood-sample.7b59d5ce.png";